import { Box, Container, useTheme } from '@mui/material';
import React from 'react';
import { ThemeToggle } from '../components/ThemeToggle/ThemeToggle';
import './AuthPage.css';

const ClipsLogo = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const logoSrc = isDark
    ? '/fmg-clips-logo-dark.svg'
    : '/fmg-clips-logo-light.svg';

  return (
    <Box className="auth-page__logo">
      <img src={logoSrc} alt="FMG Clips Logo" width="120" height="31" />
    </Box>
  );
};

interface AuthPageProps {
  children: React.ReactNode;
}

export const AuthPage: React.FC<AuthPageProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      className="auth-page"
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Box className="auth-page__theme-toggle">
        <ThemeToggle />
      </Box>

      <Container maxWidth="sm">
        <Box className="auth-page__container">
          <ClipsLogo />
          {children}
        </Box>
      </Container>
    </Box>
  );
};
